// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company_container {
  padding: 20px;
  background: #f9f9f9;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
}

/* === Header Section === */
.header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.company_title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
}

.company_title .title {
  font-size: 24px;
  color: #0d7c66;
  font-weight: bold;
}

.company-search-container {
  position: relative;
  width: 100%;
  max-width: 350px;
}

.companyCodeInput {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
}

.companyCodeInput:focus {
  border-color: #007bff;
}

.company-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 150px;
  overflow-y: auto;
  z-index: 999;
  border-radius: 0 0 6px 6px;
}

.company-suggestion-item {
  padding: 8px 12px;
  cursor: pointer;
}

.company-suggestion-item:hover {
  background-color: #f0f0f0;
}

/* === Filter Section === */
.filter-section {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 15px;
}

.filter-label {
  font-size: 11px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  display: block;
  width: 100px;
  margin-top: 10px;
}

.filter-input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: auto;
  outline: none;
  transition: 0.3s;
  color: #333;
}

.filter-input select {
  color: black !important; /* Set the text color to black */
}
.filter-input:focus {
  border-color: #76c5a7;
}
.search-button {
  padding: 6px 12px;
  border: none;
  border-radius: 5px;
  background-color: #007bff; /* Change to your preferred color */
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-left: 10px; /* Add some space from the filters */
}

.search-button:hover {
  background-color: #0056b3; /* Darker shade on hover */
}

/* === Scrollable Table Container === */
.user-table-container {
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* === Table Styles === */
.user-table {
  width: 100%;
  border-collapse: collapse;
}

.user-table th,
.user-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.user-table th {
  background-color: #deecdd;
  color: black;
  font-size: 12px;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 2;
}

.user-table td {
  font-weight: 600;
  color: #333;
  font-size: 11px;
}

/* === Action Icons === */
.action {
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-left: -60px;
}

.icon {
  cursor: pointer;
  font-size: 16px;
  transition: color 0.3s;
  color: #84c7ae;
  margin-left: -4px;
}

/* === Popup Styles === */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popap {
  position: relative;
  background: linear-gradient(rgb(248, 248, 248), rgb(225, 240, 222));
  padding: 25px;
  border-radius: 10px;
  width: 380px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.bulk_heading {
  font-size: 18px;
  color: #004c3f;
  font-weight: 600;
  margin-bottom: 15px;
}

.enterCompanyCode {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
  text-align: left;
}

.companyCodeSelect {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  outline: none;
  margin-bottom: 12px;
  background: #fff;
}

.file-upload-bulk input[type="file"] {
  display: block;
  margin: 10px auto;
  width: 100%;
  font-size: 13px;
}

.leaveiconarrow {
  color: #84c7ae;
  font-size: 13px;
  /* top: 5px; */
  position: relative;
  z-index: 1;
  margin-left: -30px;
  font-weight: 700;
  height: 24px;
}

.submitBtnmutli {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.uploadBulkBtn,
.SampleDownBtn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: white;
  transition: all 0.3s ease;
}

.uploadBulkBtn {
  background-color: rgb(116, 197, 167);
}

.uploadBulkBtn:hover {
  background-color: rgb(98, 174, 145);
}

.SampleDownBtn {
  background-color: #74c5a7;
}

/* .SampleDownBtn:hover {
  background-color: #046d58;
} */

/* === Close (Cross) Button - Inside Popup === */
.closBtnBulk {
  position: absolute;
  top: 10px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 28px;
  color: #004c3f;
  cursor: pointer;
  transition: color 0.3s ease;
}

.closeBtnBulk:hover {
  color: #ff4d4d;
}

/* === Optional: Modern Scrollbar === */
.user-table-container::-webkit-scrollbar {
  width: 6px;
}

.user-table-container::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 4px;
}

.user-table-container::-webkit-scrollbar-thumb:hover {
  background-color: #9e9e9e;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/UploadPaySlip/UploadPaySlip.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB,EAAE,gCAAgC;AAC3D;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,mCAAmC;EAC9D,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,iBAAiB,EAAE,oCAAoC;AACzD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mEAAmE;EACnE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH,gDAAgD;AAChD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".company_container {\n  padding: 20px;\n  background: #f9f9f9;\n  min-height: 100vh;\n  font-family: \"Poppins\", sans-serif;\n}\n\n/* === Header Section === */\n.header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.company_title {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.company_title .title {\n  font-size: 24px;\n  color: #0d7c66;\n  font-weight: bold;\n}\n\n.company-search-container {\n  position: relative;\n  width: 100%;\n  max-width: 350px;\n}\n\n.companyCodeInput {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  outline: none;\n}\n\n.companyCodeInput:focus {\n  border-color: #007bff;\n}\n\n.company-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-top: none;\n  max-height: 150px;\n  overflow-y: auto;\n  z-index: 999;\n  border-radius: 0 0 6px 6px;\n}\n\n.company-suggestion-item {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.company-suggestion-item:hover {\n  background-color: #f0f0f0;\n}\n\n/* === Filter Section === */\n.filter-section {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 15px;\n}\n\n.filter-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 4px;\n  display: block;\n  width: 100px;\n  margin-top: 10px;\n}\n\n.filter-input {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: auto;\n  outline: none;\n  transition: 0.3s;\n  color: #333;\n}\n\n.filter-input select {\n  color: black !important; /* Set the text color to black */\n}\n.filter-input:focus {\n  border-color: #76c5a7;\n}\n.search-button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 5px;\n  background-color: #007bff; /* Change to your preferred color */\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-left: 10px; /* Add some space from the filters */\n}\n\n.search-button:hover {\n  background-color: #0056b3; /* Darker shade on hover */\n}\n\n/* === Scrollable Table Container === */\n.user-table-container {\n  max-height: 400px;\n  overflow-y: auto;\n  border-radius: 8px;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* === Table Styles === */\n.user-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.user-table th,\n.user-table td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.user-table th {\n  background-color: #deecdd;\n  color: black;\n  font-size: 12px;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.user-table td {\n  font-weight: 600;\n  color: #333;\n  font-size: 11px;\n}\n\n/* === Action Icons === */\n.action {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  align-items: center;\n  margin-left: -60px;\n}\n\n.icon {\n  cursor: pointer;\n  font-size: 16px;\n  transition: color 0.3s;\n  color: #84c7ae;\n  margin-left: -4px;\n}\n\n/* === Popup Styles === */\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.popap {\n  position: relative;\n  background: linear-gradient(rgb(248, 248, 248), rgb(225, 240, 222));\n  padding: 25px;\n  border-radius: 10px;\n  width: 380px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.bulk_heading {\n  font-size: 18px;\n  color: #004c3f;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.enterCompanyCode {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #333;\n  text-align: left;\n}\n\n.companyCodeSelect {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  outline: none;\n  margin-bottom: 12px;\n  background: #fff;\n}\n\n.file-upload-bulk input[type=\"file\"] {\n  display: block;\n  margin: 10px auto;\n  width: 100%;\n  font-size: 13px;\n}\n\n.leaveiconarrow {\n  color: #84c7ae;\n  font-size: 13px;\n  /* top: 5px; */\n  position: relative;\n  z-index: 1;\n  margin-left: -30px;\n  font-weight: 700;\n  height: 24px;\n}\n\n.submitBtnmutli {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 15px;\n}\n\n.uploadBulkBtn,\n.SampleDownBtn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.uploadBulkBtn {\n  background-color: rgb(116, 197, 167);\n}\n\n.uploadBulkBtn:hover {\n  background-color: rgb(98, 174, 145);\n}\n\n.SampleDownBtn {\n  background-color: #74c5a7;\n}\n\n/* .SampleDownBtn:hover {\n  background-color: #046d58;\n} */\n\n/* === Close (Cross) Button - Inside Popup === */\n.closBtnBulk {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  font-size: 28px;\n  color: #004c3f;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.closeBtnBulk:hover {\n  color: #ff4d4d;\n}\n\n/* === Optional: Modern Scrollbar === */\n.user-table-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.user-table-container::-webkit-scrollbar-thumb {\n  background-color: #c4c4c4;\n  border-radius: 4px;\n}\n\n.user-table-container::-webkit-scrollbar-thumb:hover {\n  background-color: #9e9e9e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
